(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1614],{

/***/ 47306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disease-encyclopedia/[id]/[keyword]",
      function () {
        return __webpack_require__(29373);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  margin-top: auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-7e5c5516-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    \n    & > span, & > h2 {\n      ").concat(theme.typography.UI18SB, ";\n      color: ").concat(theme.color.white, ";\n    }\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7e5c5516-9"
})(_templateObject9());


/***/ }),

/***/ 71305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var HealthMedicalMedicines = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6240_2327)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.6198 6.84864C11.207 6.26149 12.0032 5.93164 12.8336 5.93164C13.6639 5.93164 14.4603 6.26149 15.0475 6.84864C15.6346 7.43578 15.9645 8.23211 15.9645 9.06245C15.9645 9.8928 15.6346 10.6891 15.0475 11.2763L11.2545 15.0691C10.6674 15.6563 9.87107 15.9862 9.04072 15.9862C8.21038 15.9862 7.41405 15.6563 6.82691 15.0691C6.23976 14.4821 5.90991 13.6857 5.90991 12.8553C5.90991 12.025 6.23976 11.2287 6.82691 10.6415L10.6198 6.84864Z",
                        fill: "#EF990D"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.8335 5.93164C12.0031 5.93164 11.2069 6.26149 10.6197 6.84864L8.72327 8.74508L13.1509 13.1727L15.0474 11.2763C15.6345 10.6891 15.9644 9.8928 15.9644 9.06245C15.9644 8.23211 15.6345 7.43578 15.0474 6.84864C14.4602 6.26149 13.6638 5.93164 12.8335 5.93164Z",
                        fill: "#F4B54F"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.43509 8.87016C6.8845 8.87016 8.87016 6.8845 8.87016 4.43509C8.87016 1.98566 6.8845 0 4.43509 0C1.98566 0 0 1.98566 0 4.43509C0 6.8845 1.98566 8.87016 4.43509 8.87016Z",
                        fill: "#339AF0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0.0572177 5.14927H8.81294C8.85059 4.91675 8.87016 4.67815 8.87016 4.43499C8.87016 4.19182 8.85059 3.95324 8.81294 3.7207H0.0572177C0.0195689 3.95324 0 4.19182 0 4.43499C0 4.67815 0.0195689 4.91675 0.0572177 5.14927Z",
                        fill: "#86C6FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_6240_2327",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HealthMedicalMedicines);


/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var log = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().log;
    var child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var handleLog = function(_e) {
            var evaluatedPayload = typeof payload === "function" ? payload() : payload;
            log({
                eventName: eventName,
                payload: evaluatedPayload
            });
        };
        var wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("click", handleLog, {
                capture: true
            });
            return function() {
                wrapper.removeEventListener("click", handleLog, {
                    capture: true
                });
            };
        }
    }, [
        eventName,
        payload,
        log,
        enabled
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: "contents",
        children: child
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 1967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkTag = function(param) {
    var href = param.href, _target = param.target, target = _target === void 0 ? "_self" : _target, children = param.children, style = param.style, onClickNavigateToScreen = param.onClickNavigateToScreen, wrapperStyle = param.wrapperStyle, className = param.className;
    return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        className: className,
        role: "button",
        onClick: onClickNavigateToScreen,
        style: wrapperStyle,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            target: target,
            style: style,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LinkTag);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1aad4008-0"
})(_templateObject());


/***/ }),

/***/ 42411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70691);
/* harmony import */ var _constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60643);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95613);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44376);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);







var AppInstallTopBanner = function(param) {
    var onClickClose = param.onClickClose, content = param.content, trackingInfo = param.trackingInfo, onLogEvent = param.onLogEvent;
    var ref = trackingInfo !== null && trackingInfo !== void 0 ? trackingInfo : {}, contentCategory = ref.contentCategory, contentId = ref.contentId, contentTitle = ref.contentTitle, campaign = ref.campaign, contentSubCategory = ref.contentSubCategory;
    var airbridgeDynamicLink = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAirbridgeDynamicLink */ .e)();
    var onClickInstallApp = function() {
        onLogEvent === null || onLogEvent === void 0 ? void 0 : onLogEvent();
        airbridgeDynamicLink.navigateWithTracking(_constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_2__/* .DeeplinkLoggerEventName.ClickCtaButton */ .l.ClickCtaButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            campaign: campaign,
            content: content,
            term: "바로 진료받기",
            sub_id: contentId,
            sub_id_1: contentTitle,
            sub_id_2: contentCategory
        }, contentSubCategory && {
            sub_id_3: contentSubCategory
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sticky top-[60px] z-[300] flex w-full items-center justify-between bg-gray-700 pt-[14px] pr-[20px] pb-[12px] pl-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onClickClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: _styles_theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.gray300 */ .Z.color.gray300,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-13m text-white",
                                children: "병원 문 닫은 늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-15sb text-white",
                                children: "닥터나우는 24시간 열려있어요!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white",
                    onClick: onClickInstallApp,
                    children: "바로 진료받기"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppInstallTopBanner);


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 18103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F9": function() { return /* binding */ DiseaseEncyclopediaFaqModel; },
/* harmony export */   "Q8": function() { return /* binding */ EDiseaseEncyclopediaBottomButtonType; },
/* harmony export */   "p6": function() { return /* binding */ DiseaseEncyclopediaBannerModel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);

var EDiseaseEncyclopediaBottomButtonType;
(function(EDiseaseEncyclopediaBottomButtonType) {
    EDiseaseEncyclopediaBottomButtonType["DiagnosisReservation"] = "DIAGNOSIS_RESERVATION";
    EDiseaseEncyclopediaBottomButtonType["None"] = "NONE";
    EDiseaseEncyclopediaBottomButtonType["Qna"] = "QNA";
})(EDiseaseEncyclopediaBottomButtonType || (EDiseaseEncyclopediaBottomButtonType = {}));
var DiseaseEncyclopediaBannerModel = function DiseaseEncyclopediaBannerModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiseaseEncyclopediaBannerModel);
    this.getButtonPhrase = function() {
        return _this.buttonPhrase;
    };
    this.getDescription = function() {
        return _this.description;
    };
    this.getExternalUrl = function() {
        return _this.externalUrl;
    };
    this.getImageUrl = function() {
        return _this.imageUrl;
    };
    this.getTitle = function() {
        return _this.title;
    };
    this.buttonPhrase = data.buttonPhrase;
    this.description = data.description;
    this.externalUrl = data.externalUrl;
    this.imageUrl = data.imageUrl;
    this.title = data.title;
};
var DiseaseEncyclopediaFaqModel = function DiseaseEncyclopediaFaqModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiseaseEncyclopediaFaqModel);
    this.getQuestion = function() {
        return _this.question;
    };
    this.getAnswer = function() {
        return _this.answer;
    };
    this.question = data.question;
    this.answer = data.answer;
};
var DiseaseEncyclopediaModel = function DiseaseEncyclopediaModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiseaseEncyclopediaModel);
    this.getDepartmentTags = function() {
        var _departmentTags;
        return (_departmentTags = _this.departmentTags) !== null && _departmentTags !== void 0 ? _departmentTags : [];
    };
    this.getJoinedDepartmentTags = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.departmentTags) === null || ref === void 0 ? void 0 : ref.join(", ")) !== null && ref1 !== void 0 ? ref1 : "";
    };
    this.getSearchTags = function() {
        var _searchTags;
        return (_searchTags = _this.searchTags) !== null && _searchTags !== void 0 ? _searchTags : [];
    };
    this.getSymptomTags = function() {
        var _symptomTags;
        return (_symptomTags = _this.symptomTags) !== null && _symptomTags !== void 0 ? _symptomTags : [];
    };
    this.getJoinedSymptomTags = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.symptomTags) === null || ref === void 0 ? void 0 : ref.join(", ")) !== null && ref1 !== void 0 ? ref1 : "";
    };
    this.getPublicId = function() {
        return _this.publicId;
    };
    this.getTitle = function() {
        return _this.title;
    };
    this.getTitleImageUrl = function() {
        var _titleImageUrl;
        return (_titleImageUrl = _this.titleImageUrl) !== null && _titleImageUrl !== void 0 ? _titleImageUrl : null;
    };
    this.getContent = function() {
        return _this.content;
    };
    this.getBanner = function() {
        return _this.banner;
    };
    this.getBottomButtonType = function() {
        return _this.bottomButtonType;
    };
    this.getFaqs = function() {
        var _faqs;
        return (_faqs = _this.faqs) !== null && _faqs !== void 0 ? _faqs : [];
    };
    this.id = data.id;
    this.publicId = data.publicId;
    this.bottomButtonType = data.bottomButtonType;
    this.content = data.content;
    this.departmentTags = data.departmentTags;
    this.searchTags = data.searchTags;
    this.title = data.title;
    this.titleImageUrl = data.titleImageUrl;
    this.symptomTags = data.symptomTags;
    this.banner = data.banner;
    this.faqs = data.faqs;
};
/* harmony default export */ __webpack_exports__["ZP"] = (DiseaseEncyclopediaModel);


/***/ }),

/***/ 1598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ createDiseaseEncyclopediaDetailUrl; },
/* harmony export */   "mR": function() { return /* binding */ createDiseaseEncyclopediaDetailUrlWithKeyword; }
/* harmony export */ });
/* unused harmony export createDiseaseEncyclopediaRedirectUrl */
/* harmony import */ var _shared_utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64214);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70138);


var createDiseaseEncyclopediaDetailUrl = function(diseaseEncyclopedia) {
    if (!diseaseEncyclopedia) {
        return "";
    }
    var publicId = diseaseEncyclopedia.getPublicId();
    var keyword = diseaseEncyclopedia.getTitle();
    return createDiseaseEncyclopediaDetailUrlWithKeyword(publicId, keyword);
};
var createDiseaseEncyclopediaDetailUrlWithKeyword = function(publicId, keyword) {
    var formattedKeyword = (0,_shared_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatKeywordForUrl */ .Z)(keyword);
    var encodedKeyword = encodeURIComponent(formattedKeyword);
    return "".concat(_types_common__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path */ .Z6.DISEASE_ENCYCLOPEDIA.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};
var extractKeywordFromDiseaseEncyclopediaData = function(diseaseEncyclopedia) {
    var ref;
    return (ref = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.title) !== null && ref !== void 0 ? ref : "";
};
var createDiseaseEncyclopediaRedirectUrl = function(publicId, diseaseEncyclopedia) {
    var keyword = extractKeywordFromDiseaseEncyclopediaData(diseaseEncyclopedia);
    return createDiseaseEncyclopediaDetailUrlWithKeyword(publicId, keyword);
};


/***/ }),

/***/ 40573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15951);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9912);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79212);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53476);






dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3___default()));
var useAppInstallTopBanner = function() {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_5__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .appInstallTopBannerState */ .Ep).isVisible;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    // 스크롤 기반 가시성 상태
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), isScrollVisible = ref[0], setIsScrollVisible = ref[1];
    var lastScrollYRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(0);
    var rafIdRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    // 스크롤 이벤트 핸들러 (RAF 최적화)
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var threshold = 700;
        var handleScroll = function() {
            // RAF가 이미 예약되어 있으면 중복 실행 방지
            if (rafIdRef.current !== null) {
                return;
            }
            rafIdRef.current = requestAnimationFrame(function() {
                var currentScrollY = window.scrollY;
                var lastScrollY = lastScrollYRef.current;
                // threshold 이하에서는 항상 표시
                if (currentScrollY < threshold) {
                    setIsScrollVisible(true);
                } else {
                    // 위로 스크롤: 표시, 아래로 스크롤: 숨김
                    if (currentScrollY < lastScrollY) {
                        setIsScrollVisible(true);
                    } else if (currentScrollY > lastScrollY) {
                        setIsScrollVisible(false);
                    }
                }
                lastScrollYRef.current = currentScrollY;
                rafIdRef.current = null;
            });
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
            }
        };
    }, []);
    var isNewAdVisibleClient = function(client) {
        var visibleClientTypes = [
            _types_app__WEBPACK_IMPORTED_MODULE_1__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB
        ];
        return visibleClientTypes.includes(client.clientType);
    };
    return {
        isVisible: isVisible,
        isNewAdVisibleClient: isNewAdVisibleClient,
        isScrollVisible: isScrollVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 29373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _keyword_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/entities/disease-encyclopedia/util/index.ts
var util = __webpack_require__(1598);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/entities/disease-encyclopedia/model/diseaseEncyclopedia.ts
var model_diseaseEncyclopedia = __webpack_require__(18103);
// EXTERNAL MODULE: ./src/shared/utils/typeGuard.ts
var typeGuard = __webpack_require__(95214);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/disease-encyclopedia/hooks/disease-encyclopedia.gql.impl.tsx


var DiseaseEncyclopediaByUserDocument = "\n    query DiseaseEncyclopediaByUser($diseaseEncyclopediaPid: ID!) {\n  diseaseEncyclopediaByUser(diseaseEncyclopediaPid: $diseaseEncyclopediaPid) {\n    bottomButtonType\n    content\n    departmentTags\n    id\n    publicId\n    searchTags\n    title\n    titleImageUrl\n    symptomTags\n    banner {\n      buttonPhrase\n      description\n      diseaseEncyclopediaId\n      externalUrl\n      id\n      imageUrl\n      title\n    }\n    faqs {\n      question\n      answer\n    }\n  }\n}\n    ";
var useDiseaseEncyclopediaByUserQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "DiseaseEncyclopediaByUser",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(DiseaseEncyclopediaByUserDocument, "DiseaseEncyclopediaByUser", variables), options);
};
useDiseaseEncyclopediaByUserQuery.getKey = function(variables) {
    return [
        "DiseaseEncyclopediaByUser",
        variables
    ];
};
useDiseaseEncyclopediaByUserQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(DiseaseEncyclopediaByUserDocument, "DiseaseEncyclopediaByUser", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/disease-encyclopedia/hooks/useDiseaseEncyclopediaByUser.ts






var parseBottomButtonType = function(bottomButtonType) {
    switch(bottomButtonType){
        case gql_schema/* DiseaseEncyclopediaBottomButtonType.DiagnosisReservation */.rdQ.DiagnosisReservation:
            return model_diseaseEncyclopedia/* EDiseaseEncyclopediaBottomButtonType.DiagnosisReservation */.Q8.DiagnosisReservation;
        case gql_schema/* DiseaseEncyclopediaBottomButtonType.None */.rdQ.None:
            return model_diseaseEncyclopedia/* EDiseaseEncyclopediaBottomButtonType.None */.Q8.None;
        case gql_schema/* DiseaseEncyclopediaBottomButtonType.Qna */.rdQ.Qna:
            return model_diseaseEncyclopedia/* EDiseaseEncyclopediaBottomButtonType.Qna */.Q8.Qna;
        default:
            return (0,typeGuard/* exhaustiveGuard */.Y)(bottomButtonType);
    }
};
var parseDiseaseEncyclopedia = function(data) {
    var ref, ref1, ref2, ref3, ref4;
    return new model_diseaseEncyclopedia/* default */.ZP({
        bottomButtonType: parseBottomButtonType(data.diseaseEncyclopediaByUser.bottomButtonType),
        content: data.diseaseEncyclopediaByUser.content,
        departmentTags: data.diseaseEncyclopediaByUser.departmentTags,
        id: data.diseaseEncyclopediaByUser.id,
        publicId: data.diseaseEncyclopediaByUser.publicId,
        searchTags: data.diseaseEncyclopediaByUser.searchTags,
        title: data.diseaseEncyclopediaByUser.title,
        titleImageUrl: data.diseaseEncyclopediaByUser.titleImageUrl,
        banner: data.diseaseEncyclopediaByUser.banner ? new model_diseaseEncyclopedia/* DiseaseEncyclopediaBannerModel */.p6({
            buttonPhrase: (ref = data.diseaseEncyclopediaByUser.banner) === null || ref === void 0 ? void 0 : ref.buttonPhrase,
            description: (ref1 = data.diseaseEncyclopediaByUser.banner) === null || ref1 === void 0 ? void 0 : ref1.description,
            externalUrl: (ref2 = data.diseaseEncyclopediaByUser.banner) === null || ref2 === void 0 ? void 0 : ref2.externalUrl,
            imageUrl: (ref3 = data.diseaseEncyclopediaByUser.banner) === null || ref3 === void 0 ? void 0 : ref3.imageUrl,
            title: (ref4 = data.diseaseEncyclopediaByUser.banner) === null || ref4 === void 0 ? void 0 : ref4.title
        }) : undefined,
        symptomTags: data.diseaseEncyclopediaByUser.symptomTags,
        faqs: data.diseaseEncyclopediaByUser.faqs.map(function(faq) {
            return new model_diseaseEncyclopedia/* DiseaseEncyclopediaFaqModel */.F9({
                question: faq.question,
                answer: faq.answer
            });
        })
    });
};
var useDiseaseEncyclopediaByUser = function(diseaseEncyclopediaPid) {
    var ref = useDiseaseEncyclopediaByUserQuery({
        diseaseEncyclopediaPid: diseaseEncyclopediaPid
    }, {
        enabled: !!diseaseEncyclopediaPid,
        select: parseDiseaseEncyclopedia,
        staleTime: 1000 * 60 * 5
    }), diseaseEncyclopedia = ref.data;
    return {
        diseaseEncyclopedia: diseaseEncyclopedia
    };
};
/* harmony default export */ var hooks_useDiseaseEncyclopediaByUser = (useDiseaseEncyclopediaByUser);
useDiseaseEncyclopediaByUser.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, diseaseEncyclopediaPid) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                queryClient.prefetchQuery({
                    queryKey: useDiseaseEncyclopediaByUserQuery.getKey({
                        diseaseEncyclopediaPid: diseaseEncyclopediaPid
                    }),
                    queryFn: useDiseaseEncyclopediaByUserQuery.fetcher({
                        diseaseEncyclopediaPid: diseaseEncyclopediaPid
                    }),
                    staleTime: 1000 * 60 * 5
                })
            ];
        });
    });
    return function(queryClient, diseaseEncyclopediaPid) {
        return _ref.apply(this, arguments);
    };
}();
useDiseaseEncyclopediaByUser.getKey = function(diseaseEncyclopediaPid) {
    return useDiseaseEncyclopediaByUserQuery.getKey({
        diseaseEncyclopediaPid: diseaseEncyclopediaPid
    });
};

// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/id/keyword/hooks/useDiseaseEncyclopediaDetailViewModel.ts











var useDiseaseEncyclopediaDetailViewModel = function(param) {
    var client = param.client, publicId = param.publicId;
    var router = (0,next_router.useRouter)();
    var navigate = (0,useNavigate/* default */.Z)();
    var id = publicId || router.query.id;
    var diseaseEncyclopedia = hooks_useDiseaseEncyclopediaByUser(id).diseaseEncyclopedia;
    var shouldShowDiseaseImage = function() {
        return !!(diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitleImageUrl());
    };
    var shouldShowDepartmentTags = function() {
        var ref;
        var ref1;
        return ((ref1 = (ref = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getDepartmentTags()) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0;
    };
    var shouldShowSearchTags = function() {
        var ref;
        var ref1;
        return ((ref1 = (ref = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getSearchTags()) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0;
    };
    var shouldShowSymptomTags = function() {
        var ref;
        var ref1;
        return ((ref1 = (ref = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getSymptomTags()) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0;
    };
    var shouldShowTableOfContents = function() {
        return !!(diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getContent());
    };
    var shouldShowContent = function() {
        return !!(diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getContent());
    };
    var shouldShowBanner = function() {
        return !!(diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getBanner());
    };
    var shouldShowCtaBottomFloatingButton = function() {
        if (client.isWebView) {
            return false;
        }
        if ((diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getBottomButtonType()) === model_diseaseEncyclopedia/* EDiseaseEncyclopediaBottomButtonType.None */.Q8.None) {
            return false;
        }
        return true;
    };
    var shouldShowFaqs = function() {
        var ref;
        var ref1;
        return ((ref1 = (ref = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getFaqs()) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0;
    };
    var handleClickCtaBottomFloatingButton = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, (0,_object_spread/* default */.Z)({}, (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()) && {
            disease: diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()
        }));
        router.push("".concat(common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path));
    };
    var shouldShowBottomFloatingSocialProof = function() {
        return (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getBottomButtonType()) === model_diseaseEncyclopedia/* EDiseaseEncyclopediaBottomButtonType.DiagnosisReservation */.Q8.DiagnosisReservation;
    };
    var getCtaBottomFloatingButtonText = function() {
        if ((diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getBottomButtonType()) === model_diseaseEncyclopedia/* EDiseaseEncyclopediaBottomButtonType.DiagnosisReservation */.Q8.DiagnosisReservation) {
            return "비대면 진료 받으러 가기";
        }
        return "실시간 의료상담 물어보기";
    };
    var getTitle = function() {
        return (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()) || "";
    };
    var getFaqTitle = function() {
        var title = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle();
        return title && shouldShowFaqs() ? title + "의 자주 묻는 질문" : "";
    };
    var getContent = function() {
        return (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getContent()) || "";
    };
    var getFaqs = function() {
        return (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getFaqs()) || [];
    };
    var getBanner = function() {
        return diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getBanner();
    };
    var onClickTopCta = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, (0,_object_spread/* default */.Z)({}, (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()) && {
            disease: diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()
        }));
    };
    var onClickOuterLink = function(url) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToPureWebViewAppScreen({
                uri: url
            });
        }
    };
    var extractTextFromChildren = function(children) {
        if (typeof children === "string") {
            return children;
        }
        if (typeof children === "number") {
            return String(children);
        }
        if (Array.isArray(children)) {
            return children.map(extractTextFromChildren).join("");
        }
        if (react.isValidElement(children) && children.props && children.props.children) {
            return extractTextFromChildren(children.props.children);
        }
        return "";
    };
    (0,react.useEffect)(function() {
        if (diseaseEncyclopedia) {
            pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, (diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()) && {
                disease: diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.getTitle()
            }));
        }
    }, [
        diseaseEncyclopedia
    ]);
    return {
        diseaseEncyclopedia: diseaseEncyclopedia,
        shouldShowDiseaseImage: shouldShowDiseaseImage,
        shouldShowDepartmentTags: shouldShowDepartmentTags,
        shouldShowSearchTags: shouldShowSearchTags,
        shouldShowSymptomTags: shouldShowSymptomTags,
        shouldShowBanner: shouldShowBanner,
        shouldShowTableOfContents: shouldShowTableOfContents,
        shouldShowCtaBottomFloatingButton: shouldShowCtaBottomFloatingButton,
        shouldShowBottomFloatingSocialProof: shouldShowBottomFloatingSocialProof,
        getCtaBottomFloatingButtonText: getCtaBottomFloatingButtonText,
        shouldShowContent: shouldShowContent,
        showShowFaqs: shouldShowFaqs,
        handleClickCtaBottomFloatingButton: handleClickCtaBottomFloatingButton,
        getContent: getContent,
        getBanner: getBanner,
        getTitle: getTitle,
        getFaqTitle: getFaqTitle,
        getFaqs: getFaqs,
        onClickTopCta: onClickTopCta,
        onClickOuterLink: onClickOuterLink,
        extractTextFromChildren: extractTextFromChildren
    };
};
/* harmony default export */ var hooks_useDiseaseEncyclopediaDetailViewModel = (useDiseaseEncyclopediaDetailViewModel);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/atom/icon/layout/HealthMedicalMedicines.tsx
var HealthMedicalMedicines = __webpack_require__(71305);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(42411);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/header.ts
var header = __webpack_require__(37072);
// EXTERNAL MODULE: ./src/utils/style.ts + 1 modules
var style = __webpack_require__(13195);
;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaBanner.tsx



var DiseaseEncyclopediaBanner = function(param) {
    var client = param.client, banner = param.banner;
    var onClick = function() {
        if (banner) {
            window.open(banner.getExternalUrl(), "_blank");
        }
    };
    if (!banner) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.cn)("mx-[24px] mb-[32px] flex items-center justify-between rounded-[16px] bg-gray-30 p-[24px]", {
            "aspect-[722/174]": !client.isMobile,
            "aspect-[312/174]": client.isMobile
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "typography-ui-17sb mb-[2px] text-gray-800",
                        children: banner.getTitle()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "typography-ui-15m mb-[16px] flex-1 break-keep text-gray-500",
                        children: banner.getDescription()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: onClick,
                        className: "typography-ui-15sb mt-auto h-[40px] w-fit rounded-[8px] bg-primary-600 px-[12px] text-white",
                        children: banner.getButtonPhrase()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (0,style.cn)("aspect-square", {
                    "h-[100px] w-[100px]": client.isMobile,
                    "h-[120px] w-[120px]": !client.isMobile
                }),
                src: (ref = banner.getImageUrl()) !== null && ref !== void 0 ? ref : "",
                alt: "닥터나우 진료 이미지"
            })
        ]
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaBanner = (DiseaseEncyclopediaBanner);

;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaFaq.tsx

var DiseaseEncyclopediaFaq = function(param) {
    var faqTitle = param.faqTitle, faqs = param.faqs;
    if (!faqs || faqs.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-[40px] flex flex-col gap-4 px-[24px]",
        id: "".concat(faqTitle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "typography-ui-24sb text-gray-900",
                    children: faqTitle
                })
            }),
            faqs.map(function(faq, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-[20px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[8px] flex items-center gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex h-[28px] w-[28px] flex-shrink-0 items-center justify-center rounded-[40px] bg-gray-700",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "typography-ui-13m text-white",
                                        children: [
                                            "Q",
                                            index + 1
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "typography-ui-19sb text-gray-700",
                                    children: faq.getQuestion()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pl-[42px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "typography-article-18r text-gray-600",
                                children: faq.getAnswer()
                            })
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaFaq = (DiseaseEncyclopediaFaq);

;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaGuideInfo.tsx

var DiseaseEncyclopediaGuideInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "typography-ui-15r mx-[24px] flex flex-col gap-[8px] pb-[24px] pl-[20px] text-gray-400 marker:mr-[2px] marker:text-gray-400",
        children: [
            "해당 정보는 지식 제공을 위한 참고사항이며, 법적 책임이 발생하지 않습니다.",
            "질환 관련 의학적 조언이나 진단 등 전문적 소견이 필요하시다면, 의료진 등 전문가와 상담하시기 바랍니다.", 
        ].map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: 'relative cursor-none before:absolute before:top-[10px] before:left-[-13px] before:block before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-400 before:content-[""]',
                children: item
            }, item);
        })
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaGuideInfo = (DiseaseEncyclopediaGuideInfo);

;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaHeader.tsx


var DiseaseEncyclopediaHeader = function(props) {
    var ref;
    var isMobileEnv = props.client.isMobile;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.cn)("flex pb-[32px]", {
            "flex-col": isMobileEnv
        }, {
            "pt-[28px] pr-[24px]": !isMobileEnv
        }, {
            "gap-[32px]": props.shouldShowDiseaseImage
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)("flex flex-col gap-[4px]", {
                    "ml-[24px]": !isMobileEnv
                }),
                children: props.shouldShowDiseaseImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (ref1 = (ref = props.diseaseEncyclopedia) === null || ref === void 0 ? void 0 : ref.getTitleImageUrl()) !== null && ref1 !== void 0 ? ref1 : "",
                    alt: "title-image",
                    className: (0,style.cn)("object-cover", {
                        "aspect-[160/160] h-auto w-full": isMobileEnv,
                        "h-[160px] w-[160px] rounded-[12px]": !isMobileEnv
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.cn)("flex flex-col justify-center gap-[12px]", {
                    "mx-[24px]": isMobileEnv
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "typography-ui-24b text-gray-900",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[8px]",
                        children: [
                            props.shouldShowDepartmentTags && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start gap-[20px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "typography-ui-15m min-w-[40px] text-gray-400",
                                        children: "진료과"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-wrap gap-[6px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "typography-ui-15r text-gray-900",
                                            children: props.joinedDepartmentTags
                                        })
                                    })
                                ]
                            }),
                            props.shouldShowSymptomTags && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start gap-[20px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "typography-ui-15m min-w-[40px] text-gray-400",
                                        children: "증상"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-wrap gap-[6px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "typography-ui-15r text-gray-900",
                                            children: props.joinedSymptomTags
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaHeader = (DiseaseEncyclopediaHeader);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
;// CONCATENATED MODULE: ./src/constants/logs/encyclopedia/index.ts
var ENCYCLOPEDIA_LOG_EVENT = {
    CLICK_OUTER_LINK: "click_outer_link"
};

// EXTERNAL MODULE: ./src/shared/ui/content-mark-down/ContentMarkDown.tsx
var ContentMarkDown = __webpack_require__(26324);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaMarkDown.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  iframe {\n    margin-bottom: 40px;\n\n    @media screen and (max-width: ",
        ") {\n      margin-bottom: 28px;\n      width: 100%;\n    }\n  }\n\n  p,\n  figure {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 16px;\n  }\n\n  h1 {\n    margin-bottom: 16px;\n\n    @media screen and (max-width: ",
        ") {\n      margin-bottom: 12px;\n    }\n  }\n\n  h2 {\n    width: 100%;\n    ",
        ";\n    color: ",
        ";\n    margin-top: 56px;\n    margin-bottom: 16px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n      margin-bottom: 12px;\n    }\n  }\n\n  h3 {\n    width: 100%;\n    ",
        ";\n    color: ",
        ";\n    margin-top: 16px;\n    margin-bottom: 16px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n      margin-bottom: 12px;\n    }\n  }\n\n  img {\n    max-width: 736px;\n    width: 100%;\n    height: auto;\n    position: relative;\n    border-radius: 12px;\n    margin-bottom: 24px;\n  }\n\n  ul {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 16px;\n\n    li {\n      position: relative;\n      padding-left: 24px;\n      cursor: inherit;\n\n      &:before {\n        content: '';\n        width: 4px;\n        height: 4px;\n        border-radius: 50%;\n        background-color: ",
        ";\n        display: block;\n        position: absolute;\n        left: 10px;\n        top: 10px;\n      }\n    }\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n      margin-bottom: 28px;\n    }\n  }\n\n  ol {\n    p {\n      white-space: pre-wrap;\n    }\n\n    ",
        ";\n    color: ",
        ";\n    margin: 0 0 28px 0;\n    padding-inline-start: 28px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n    list-style: auto;\n  }\n\n  li {\n    word-break: break-word;\n\n    &:not(:last-of-type) {\n      margin-bottom: 12px;\n    }\n\n    ul,\n    ol {\n      margin-top: 16px;\n      margin-bottom: 0;\n\n      li {\n        &:before {\n          content: '';\n          width: 4px;\n          height: 4px;\n          border-radius: 50%;\n          background-color: ",
        ";\n          border: 1px solid ",
        ";\n          display: block;\n          position: absolute;\n          left: 10px;\n          top: 10px;\n        }\n      }\n    }\n  }\n\n  a, .encyclopedia-link {\n    color: ",
        ";\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 16px;\n    border: 1px solid ",
        ";\n\n    thead {\n      ",
        ";\n      color: ",
        ";\n      background-color: ",
        ";\n\n      th {\n        padding: 16px;\n        border: 1px solid ",
        ";\n      }\n    }\n\n    tbody {\n      ",
        ";\n      color: ",
        ";\n\n      td {\n        border: 1px solid ",
        ";\n        padding: 16px;\n        text-align: center;\n        vertical-align: middle;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DiseaseEncyclopediaMarkDown = function(param) {
    var content = param.content, onClickOuterLink = param.onClickOuterLink, extractTextFromChildren = param.extractTextFromChildren, encyclopediaPid = param.encyclopediaPid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "mb-[40px] px-[24px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMarkDown/* default */.Z, {
            markdown: content,
            components: {
                h2: function(node) {
                    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        rest[_key - 1] = arguments[_key];
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: "".concat(node.children)
                    }, rest), {
                        children: node.children
                    }));
                },
                h3: function(node) {
                    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        rest[_key - 1] = arguments[_key];
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: "".concat(node.children)
                    }, rest), {
                        children: node.children
                    }));
                },
                h4: function(node) {
                    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        rest[_key - 1] = arguments[_key];
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: "".concat(node.children)
                    }, rest), {
                        children: node.children
                    }));
                },
                div: function(node) {
                    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        rest[_key - 1] = arguments[_key];
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: node.className
                    }, rest), {
                        children: node.children
                    }));
                },
                p: function(node) {
                    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        rest[_key - 1] = arguments[_key];
                    }
                    if (typeof node.children[0] === "object") {
                        var element = node.children[0];
                        if (element.type === "img") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                children: node.children
                            });
                        }
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                        children: node.children
                    }));
                },
                a: function(node) {
                    var _href, _href1, _href2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                        params: {
                            eventName: ENCYCLOPEDIA_LOG_EVENT.CLICK_OUTER_LINK,
                            payload: {
                                encyclopediaPid: encyclopediaPid !== null && encyclopediaPid !== void 0 ? encyclopediaPid : "",
                                linkUrl: (_href = node.href) !== null && _href !== void 0 ? _href : "",
                                linkText: extractTextFromChildren(node.children)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                            href: (_href1 = node.href) !== null && _href1 !== void 0 ? _href1 : "",
                            onClickNavigateToScreen: function() {
                                return onClickOuterLink((_href2 = node.href) !== null && _href2 !== void 0 ? _href2 : "");
                            },
                            target: "_blank",
                            className: "encyclopedia-link",
                            wrapperStyle: {
                                display: "inline-block"
                            },
                            children: node.children
                        })
                    });
                }
            }
        })
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaMarkDown = (DiseaseEncyclopediaMarkDown);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c806949-0"
})(_templateObject(), layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.ARTICLE18R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI24SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI18SB;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI18R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI18R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.color.blue500;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});

;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaSearchTagList.tsx

var DiseaseEncyclopediaSearchTagList = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-[24px] flex items-start gap-[20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap gap-[6px]",
            children: props.searchTags.map(function(tag) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "typography-ui-13m block rounded-[40px] border border-gray-100 border-solid px-[12px] py-[4px] text-gray-600",
                    children: tag
                }, tag);
            })
        })
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaSearchTagList = (DiseaseEncyclopediaSearchTagList);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/widgets/disease-encyclopedia-detail/ui/DiseaseEncyclopediaTableOfContents.tsx


function DiseaseEncyclopediaTableOfContents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-bottom: 16px;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    DiseaseEncyclopediaTableOfContents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-left: ",
        "px;\n  margin-bottom: 8px;\n  ",
        ";\n  color: ",
        ";\n  position: relative;\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n\n  &:before {\n    content: '';\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background-color: ",
        ";\n    display: ",
        ";\n    position: absolute;\n    left: 20px;\n    top: 10px;\n  }\n\n  a {\n    outline: none;\n    color: ",
        ";\n    cursor: pointer;\n    text-decoration: underline;\n    color: ",
        " !important;\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DiseaseEncyclopediaTableOfContents = function(props) {
    var headings = props.content.split("\n").filter(function(t) {
        return t.includes("# ");
    });
    var results = (0,react.useMemo)(function() {
        var order = 0;
        var ref;
        return headings.filter(function(str) {
            return str[0] === "#";
        }).filter(function(str) {
            var ref1, ref2;
            return ((ref1 = str.match(/#/g)) === null || ref1 === void 0 ? void 0 : ref1.length) && ((ref = (ref2 = str.match(/#/g)) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref !== void 0 ? ref : 0) < 3;
        }).map(function(item) {
            var ref;
            var count = (ref = item.match(/#/g)) === null || ref === void 0 ? void 0 : ref.length;
            var padding = 0;
            // 목차에 기본 사용될 태그가 h2이니 h3는 마진을 주어서 계층 구조 표현
            if (count && count > 2) {
                padding = count * 10;
            }
            //h2 태그일 경우만 order를 사용한다.
            if (count === 2) {
                ++order;
                return {
                    title: item.split("# ")[1].replace(/`/g, "").trim(),
                    padding: padding !== null && padding !== void 0 ? padding : 0,
                    order: order
                };
            }
            return {
                title: item.split("# ")[1].replace(/`/g, "").trim(),
                padding: padding !== null && padding !== void 0 ? padding : 0
            };
        });
    }, [
        headings
    ]);
    var resultsWithFaq = (0,react.useMemo)(function() {
        var baseResults = (0,_to_consumable_array/* default */.Z)(results);
        if (props.hasFaq && props.faqTitle) {
            var nextOrder = baseResults.filter(function(item) {
                return item.order;
            }).length + 1;
            baseResults.push({
                title: props.faqTitle,
                padding: 0,
                order: nextOrder
            });
        }
        return baseResults;
    }, [
        results,
        props.hasFaq,
        props.faqTitle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-[24px] mb-[40px] flex flex-col rounded-[12px] bg-gray-40 px-[24px] pt-[32px] pb-[32px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "원하는 정보 빠르게 찾기"
            }),
            resultsWithFaq.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    padding: item.padding,
                    children: [
                        item.order ? "".concat(item.order, ". ") : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#".concat(item.title),
                            children: item.title
                        })
                    ]
                }, item.title);
            })
        ]
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaTableOfContents = (DiseaseEncyclopediaTableOfContents);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9ab6e71-0"
})(DiseaseEncyclopediaTableOfContents_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI18SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI16SB;
});
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9ab6e71-1"
})(_templateObject1(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
}, function(param) {
    var padding = param.padding;
    return padding ? "block" : "none";
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});

// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/id/keyword/ui/DiseaseEncyclopediaDetailView.tsx

function DiseaseEncyclopediaDetailView_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    DiseaseEncyclopediaDetailView_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DiseaseEncyclopediaDetailView_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  gap: 8px;\n"
    ]);
    DiseaseEncyclopediaDetailView_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



















var ref, ref1, ref2, ref3;
var DiseaseEncyclopediaDetailView = function(param) {
    var viewModel = param.viewModel, topBannerViewModel = param.topBannerViewModel, client = param.client;
    var ref4, ref5, ref6, ref7, ref8, ref9;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                type: header/* HeaderType.WithMobileHeader */.n.WithMobileHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: viewModel.getTitle(),
                    hasLeftBackButton: true,
                    onClickBackButton: RNPlugins/* historyBack */.$i
                })
            }),
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                    onLogEvent: viewModel.onClickTopCta,
                    onClickClose: topBannerViewModel.hideBanner,
                    content: "web_content_bnr_service",
                    trackingInfo: {
                        campaign: "web_disease_encyclopedia",
                        contentId: (ref4 = viewModel.diseaseEncyclopedia) === null || ref4 === void 0 ? void 0 : ref4.getPublicId(),
                        contentTitle: (ref5 = viewModel.diseaseEncyclopedia) === null || ref5 === void 0 ? void 0 : ref5.getTitle()
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaHeader, {
                        client: client,
                        shouldShowDiseaseImage: viewModel.shouldShowDiseaseImage(),
                        shouldShowDepartmentTags: viewModel.shouldShowDepartmentTags(),
                        shouldShowSymptomTags: viewModel.shouldShowSymptomTags(),
                        title: viewModel.getTitle(),
                        diseaseEncyclopedia: viewModel.diseaseEncyclopedia,
                        joinedDepartmentTags: (ref = (ref6 = viewModel.diseaseEncyclopedia) === null || ref6 === void 0 ? void 0 : ref6.getJoinedDepartmentTags()) !== null && ref !== void 0 ? ref : "",
                        joinedSymptomTags: (ref1 = (ref7 = viewModel.diseaseEncyclopedia) === null || ref7 === void 0 ? void 0 : ref7.getJoinedSymptomTags()) !== null && ref1 !== void 0 ? ref1 : ""
                    }),
                    viewModel.shouldShowTableOfContents() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaTableOfContents, {
                        content: viewModel.getContent(),
                        hasFaq: viewModel.showShowFaqs(),
                        faqTitle: viewModel.getFaqTitle()
                    }),
                    viewModel.shouldShowContent() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaMarkDown, {
                        content: viewModel.getContent(),
                        onClickOuterLink: viewModel.onClickOuterLink,
                        extractTextFromChildren: viewModel.extractTextFromChildren,
                        encyclopediaPid: (ref2 = (ref8 = viewModel.diseaseEncyclopedia) === null || ref8 === void 0 ? void 0 : ref8.getPublicId()) !== null && ref2 !== void 0 ? ref2 : ""
                    }),
                    viewModel.showShowFaqs() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaFaq, {
                        faqTitle: viewModel.getFaqTitle(),
                        faqs: viewModel.getFaqs()
                    }),
                    viewModel.shouldShowBanner() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaBanner, {
                        banner: viewModel.getBanner(),
                        client: client
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaGuideInfo, {}),
                    viewModel.shouldShowSearchTags() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaSearchTagList, {
                        searchTags: (ref3 = (ref9 = viewModel.diseaseEncyclopedia) === null || ref9 === void 0 ? void 0 : ref9.getSearchTags()) !== null && ref3 !== void 0 ? ref3 : []
                    })
                ]
            }),
            viewModel.shouldShowCtaBottomFloatingButton() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyButtonWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            type: "button",
                            buttonStyle: "contained",
                            buttonColor: "primary",
                            size: "xl",
                            className: "w-full",
                            onClick: viewModel.handleClickCtaBottomFloatingButton,
                            children: viewModel.getCtaBottomFloatingButtonText()
                        }),
                        viewModel.shouldShowBottomFloatingSocialProof() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthMedicalMedicines/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                            children: "오늘 "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                            children: "1,379명"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                            children: "이 비대면 진료로 처방받았어요"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[32px]"
            })
        ]
    });
};
var StickyButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9cb981e-0"
})(DiseaseEncyclopediaDetailView_templateObject());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9cb981e-1"
})(DiseaseEncyclopediaDetailView_templateObject1());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e9cb981e-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e9cb981e-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, ";\n    color: ").concat(theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e9cb981e-4"
})(_templateObject4());
/* harmony default export */ var ui_DiseaseEncyclopediaDetailView = (DiseaseEncyclopediaDetailView);

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/id/keyword/index.ts



// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/disease-encyclopedia/[id]/[keyword]/index.tsx








var createDiseaseEncyclopediaDetailLdJson = function(diseaseEncyclopedia) {
    if (!diseaseEncyclopedia) {
        return {};
    }
    return (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "MedicalCondition",
        name: diseaseEncyclopedia.getTitle(),
        image: diseaseEncyclopedia.getTitleImageUrl(),
        url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path */.Z6.DISEASE_ENCYCLOPEDIA.DETAIL.path, "/").concat(diseaseEncyclopedia.getPublicId(), "/").concat(diseaseEncyclopedia.getTitle())
    }, diseaseEncyclopedia.getFaqs().length > 0 && {
        mainEntityOfPage: {
            "@type": "FAQPage",
            mainEntity: diseaseEncyclopedia.getFaqs().map(function(faq) {
                return {
                    "@type": "Question",
                    name: faq.getQuestion(),
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: faq.getAnswer()
                    }
                };
            })
        }
    });
};
var DiseaseEncyclopediaDetailWithKeywordPage = function(param) {
    var client = param.client, publicId = param.publicId;
    var ref, ref1, ref2;
    var viewModel = hooks_useDiseaseEncyclopediaDetailViewModel({
        client: client,
        publicId: publicId
    });
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var ldJson = createDiseaseEncyclopediaDetailLdJson(viewModel.diseaseEncyclopedia);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat((ref = viewModel.diseaseEncyclopedia) === null || ref === void 0 ? void 0 : ref.getTitle(), " 정의, 원인, 증상, 치료법, 주의사항 총정리 - 닥터나우 질환백과"),
                canonical: "".concat("https://doctornow.co.kr").concat((0,util/* createDiseaseEncyclopediaDetailUrl */.$f)(viewModel.diseaseEncyclopedia)),
                description: "".concat((ref1 = viewModel.diseaseEncyclopedia) === null || ref1 === void 0 ? void 0 : ref1.getTitle(), "의 정의와 원인, 주요 증상, 치료법, 주의사항까지. 닥터나우 질환백과에서 ").concat((ref2 = viewModel.diseaseEncyclopedia) === null || ref2 === void 0 ? void 0 : ref2.getTitle(), "에 대한 모든 정보를 확인해보세요.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaDetailView, {
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel,
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _keyword_ = (DiseaseEncyclopediaDetailWithKeywordPage);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 26324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91650);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35082);
/* harmony import */ var remark_breaks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51981);
/* harmony import */ var remark_gfm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20570);





var ContentMarkDown = function(param) {
    var markdown = param.markdown, components = param.components, footNotesTitleLabel = param.footNotesTitleLabel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_1__/* .ReactMarkdown */ .D, {
        rehypePlugins: [
            rehype_raw__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        ],
        remarkPlugins: [
            remark_gfm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            remark_breaks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
        ],
        remarkRehypeOptions: {
            footnoteLabel: footNotesTitleLabel !== null && footNotesTitleLabel !== void 0 ? footNotesTitleLabel : "참고자료"
        },
        components: components,
        children: markdown
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentMarkDown);


/***/ }),

/***/ 64214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatKeywordForUrl; },
/* harmony export */   "m": function() { return /* binding */ formatAuthorType; }
/* harmony export */ });
var formatKeywordForUrl = function(keyword) {
    var formattedKeyword = keyword.replace(/\/([^\s/]+)/g, "($1)") // /포 → (포), 한글 포함
    .replace(/[\s+]+/g, "-") // 공백, + → 하이픈
    .replace(/%/g, "퍼센트") // % → 퍼센트
    .replace(/[=&?#]/g, ""); // =, &, ?, # → 제거
    return formattedKeyword;
};
var formatAuthorType = function(authorType) {
    return authorType.split("_").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join("");
};


/***/ }),

/***/ 95214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ exhaustiveGuard; }
/* harmony export */ });
function exhaustiveGuard(_value) {
    throw new Error("ERROR! Reached forbidden guard function with unexpected value: ".concat(JSON.stringify(_value)));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2498,9653,9774,2888,179], function() { return __webpack_exec__(47306); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);